import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  background: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundRepeat: 'no-repeat',
    //backgroundColor: '#17161c',
    zIndex: -1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  brandingWrapper: {
    transform: 'translate(0, -10%)'
  },
  gridContainer: { width: '90%', maxWidth: 810, minHeight: 470 },
  gridItemPreview: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#252531',
    opacity: '0.9',
    paddingBottom: 10,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    flexGrow: 1,
  },
  gridItemMain: {
    background: '#ffffff',
    display: 'flex',
    //flexDirection: 'column',
    //justifyContent: 'center',
    //padding: '80px 0',
    alignItems: 'center',
    width: '100%',
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
    flexGrow: 1,
  },

  loginHeading: {
    fontWeight: 600,
    marginBottom: 20
  },

  heading: { fontSize: 16 },
  field: { marginBottom: 20 },

  paper: { paddingLeft: `50px`, background: 'transparent', width: '80%' },
  logoImage: {
    width: '125px',
    marginRight: '71px'
  },
  brandName: {
    fontFamily: 'Caudex, serif',
    fontSize: 22,
    color: '#08090a',
    color: '#ffffff',
    fontSize: 30,
    fontWeight: 600,
    letterSpacing: 5,
    marginTop: 2
  },

  brandSlogan: {
    color: '#ffffff',
    fontSize: 12,
    lineHeight: '0.5'
  },

  errorMessage: {
    backgroundColor: '#f8d7da',
    border: '1px solid #f8d7da',
    borderRadius: '.25rem',
    color: '#721c24',
    fontSize: 14,
    marginBottom: '1rem',
    padding: '5px 10px'
  },

  submitButton: {
    padding: '10px 20px',
    borderRadius: 6,
    background: 'linear-gradient(45deg, #ffd04d 30%, #e39f29 90%)'
  },
  linkButton: {
    display: 'block',
    background: 'transparent',
    border: 0,
    color: '#806427',
    float: 'right',
    cursor: 'pointer'
  },
  link: { cursor: 'pointer' }
}));
